import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MainNavbar from "./MainNavbar";
import axios from "axios";
import Hero from "./Hero";
import Loader from "../customcms/src/components/admin/Loader";
import { Footer } from "./Footer";
import BlogMainContent from "../customcms/src/components/admin/BlogMainContent";

export const LeaderShip = () => {
    const { pathname } = useLocation();

    const apiBaseUrl = process.env.REACT_APP_API_PATH;
    const navigate = useNavigate();
    const [pages, setPages] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const fetchPage = async () => {
            try {
                const response = await axios.get(`${apiBaseUrl}/pages/${pathname}`);
                setPages(response.data);
                if (response.status === 200) {
                    setLoading(false);
                }
            } catch (err) {
                navigate('/')
                setLoading(false);
            }
        };
        fetchPage();
    }, [pathname, apiBaseUrl]);
    return (

        <>
            <MainNavbar />
            {loading === true ? <><Loader /></> : <>
                {pages.title && <Hero bgImage={pages.featuredImages[0] && pages.featuredImages[0]} imageText={{ title: pages?.title }} />}
                <BlogMainContent content={pages?.content} className="flex-grow" />
            </>}

            <Footer />
        </>
    )
}